import {
    FETCH_DASHBOARD_USER,
    SAVE_DASHBOARD_USER,
    DELETE_DASHBOARD_USER
} from '../types';
import api from '../api';

export const fetchDashboardUsers = () => {
    return {
        type: FETCH_DASHBOARD_USER,
        payload: api.dashboardUsers.getAll(),
    };
};

export const saveDashboardUser = (user) => {
    if (user.id) {
        return {
            type: SAVE_DASHBOARD_USER,
            payload: api.dashboardUsers.update(user),
            meta: { userId: user.id, toastSuccess: true }
        };
    } else {
        return {
            type: SAVE_DASHBOARD_USER,
            payload: api.dashboardUsers.create(user),
            meta: { toastSuccess: true }
        };
    }
};

export const deleteDashboardUser = (userId) => {
    return {
        type: DELETE_DASHBOARD_USER,
        payload: api.dashboardUsers.delete(userId),
        meta: { userId, toastSuccess: true }
    };
};

